<template>
    <div>
        <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
        <b-card>
            <b-row class="mb-2 align-items-center">
                <b-col cols="8">
                    <h3 class="mr-50">
                    <feather-icon size="20" icon="FileIcon" />
                    أنواع المعاملات
                    </h3>


                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">

                    <data-table ref="transactionDescriptionTable" ep="v2/ministry/transaction-types" striped :fields="fields">
                        <template #cell(type)="{ value }">

                            <b-badge v-if="value === 0" variant="light-success"> داخلية </b-badge>
                            <b-badge v-else variant="light-danger"> خارجية </b-badge>
                        </template>
                        <template #cell(is_announcement)="{ value }">

                            <b-badge v-if="value === 1" variant="light-secondary"> نعم </b-badge>
                            <b-badge v-else variant="light-secondary"> لا </b-badge>
                        </template>
                        <template #cell(actions)="row">
                            <div class="d-flex align-items-center justify-content-end">
                            <b-button
                                variant="flat-info"
                                @click="id=row.item.id; row.toggleDetails()"
                                title="عرض المزيد من المعلومات"
                                size="sm"
                                class="btn-icon rounded-circle"
                                v-b-tooltip.hover.v-info.top
                            >
                                <feather-icon icon="InfoIcon" size="1.8x" color="#4fc98c" />
                            </b-button>
                            <b-dropdown
                                variant="link"
                                no-caret
                                :left="$store.state.appConfig.isRTL"
                            >
                                <template #button-content>
                                <feather-icon
                                    icon="MoreVerticalIcon"
                                    size="16"
                                    class="align-middle text-body"
                                />
                                </template>

                                <b-dropdown-item
                                v-can="{ slug: $route.meta.slug, action: 'U' }"
                                @click="onClickedEdit(row.item.id)"
                                :disabled="loading"
                                >
                                <feather-icon icon="EditIcon" />
                                <span class="align-middle ml-50">تعديل</span>
                                </b-dropdown-item>
                            </b-dropdown>
                            </div>
                        </template>
                        <template #row-details="row">
                            <b-card  v-show="id === row.item.id">
                            <b-row class="mb-2">
                                <b-col md="12" class="mb-1 d-flex">
                                <div>
                                    <strong>وصف المعاملة :</strong>
                                </div>
                                </b-col>
                                <b-col cols="12">

                                    <div class="text-info mx-1">
                                        <div v-if="loading" >
                                            <b-skeleton width="1500px"  height="100px"  ></b-skeleton>
                                        </div>
                                        <div v-else>
                                            <p v-html="TransactionType.description"></p>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>

                            <b-button
                                size="sm"
                                variant="outline-secondary"
                                @click="row.toggleDetails"
                            >
                                عرض اقل
                            </b-button>
                            </b-card>
                        </template>
                    </data-table>
                </b-col>

            </b-row>

        </b-card>
        <b-modal
            v-model="editModal"
            footer-class="removed"
            centered
            no-close-on-backdrop
            v-bind="$attrs"
            v-on="$listeners"
            title="تعديل معلومات معاملة"
        >
        <div>
            <validation-observer ref="activityValidation">

                <b-form @submit.prevent>
                    <b-row v-if="loading">
                        <b-skeleton width="100%" height="200px" ></b-skeleton>
                    </b-row>
                    <b-row v-else>
                        <b-col cols="12">
                            <validation-provider
                                #default="{ errors }"
                                name="priority"
                                rules="required"
                                >
                                <form-input
                                    v-if="form"
                                    v-model="form.priority"
                                    rules="required|integer|min:1|max:2"
                                    label="أولوية المعاملة"
                                />
                                <small class="text-danger">{{
                                    errors[0] ? "الحقل مطلوب" : ""
                                }}</small>
                            </validation-provider>


                            <!-- <form-cleave
                                v-model="form.priority"
                                rules="required"
                                label="أولوية المعاملة"
                                isNumber
                                :charsCount="2"
                            /> -->
                        </b-col>

                        <b-col cols="12">
                        <label for="login-password">نص توضيحي حول المعاملة </label>

                            <validation-provider
                                #default="{ errors }"
                                name="description"
                                rules="required"
                                >
                                <quill-editor
                                    v-model="form.description"
                                    :class="{ quillEditor: errors.length > 0 }"
                                    :options="editorOption"
                                />
                                <small class="text-danger">{{
                                    errors[0] ? "الحقل مطلوب" : ""
                                }}</small>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <hr />
                    <b-row class="px-1 my-1 justify-content-end">
                        <b-button @click="editModal = false" class="mx-1">إلغاء</b-button>
                        <loader-btn
                            variant="success"
                            @click="onConfirmEdit"
                            :loading="loadingUpdate"
                            label="تعديل"
                            loadingLabel="جاري التعديل ..."

                        ></loader-btn>
                    </b-row>
                </b-form>
            </validation-observer>
        </div>

      </b-modal>
    </div>
</template>
<script>
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { BCard , BRow , BCol , BSkeleton , BButton , BDropdown , BDropdownItem , BBadge , BForm} from "bootstrap-vue";
import FormInput from "@/components/form-input";
import FormCleave from "@/components/FormCleave";
import DataTable from "@/components/data-table";
import { mapActions, mapGetters } from "vuex";
import loaderBtn from "@/components/loader-btn";
import { VBTooltip } from "bootstrap-vue";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.snow.css";
export default {
  components: {
    MinistryBreadcrumbs , BCard , DataTable , BRow , BCol , BSkeleton , BButton , BDropdown , BDropdownItem , BBadge , BForm , loaderBtn , quillEditor , ValidationProvider, ValidationObserver , FormInput , FormCleave
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
    id: null ,
    editModal : false ,
    form : {} ,
    editorOption: {
    modules: {
        toolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['link'],
        ]
    }
    },
      mainTitle: "إدارة المعاملات",
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "أنواع المعاملات",
          active: true,
        },
      ],
      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        {
          key: "name",
          label: "اسم المعاملة",
        },
        {
          key: "is_announcement",
          label: "معاملة إعلام / ليست معاملة إعلام ؟",
        },
        {
          key: "type",
          label: "داخلية / خارجية ؟",
        },
        {
          key: "priority",
          label: "الأولوية",
        },
        {
          key: "total_duration",
          label: "المدة اللازمة لتنفيذ المعاملة",
        },
        { key: "actions", label: " " },
      ],

    };
  },
  computed: {
    ...mapGetters("Ministry/Settings/TransactionManagement", ["TransactionType" , "loading" , "loadingUpdate"]),
  },
  methods:{
    ...mapActions("Ministry/Settings/TransactionManagement", ["fetchTransactionTypeById" , "updateTransactionType"]),
    async onClickedEdit(id){
        this.form = {}
        await this.fetchTransactionTypeById(id).then(()=>{
            this.form.id = id
            this.form.name = this.TransactionType.name
            this.form.description = this.TransactionType.description
            this.form.is_announcement = this.TransactionType.is_announcement
            this.form.type = this.TransactionType.type
            this.form.priority = this.TransactionType.priority
            this.form.total_duration = this.TransactionType.total_duration
            this.editModal= true
        })



    },
    async onConfirmEdit(){
        await this.$refs.activityValidation.validate().then(async (success) => {
            if (success) {
                this.updateTransactionType(this.form).then(() => {

            this.$refs.transactionDescriptionTable.refreshTable();
            this.editModal = false
            })
            .catch((err) => {
            console.log(err)
            });
            }
        });
    }
  },
  watch:{
    async id(val) {
        await this.fetchTransactionTypeById(val)

    },
   }
};
</script>
